import React, { createContext, useCallback, useMemo, useState } from 'react'

import type { IMockModeContext, IProps } from './interfaces'

const STORAGE_KEY = 'wijmobiel:mock-mode'

const readPersistedValue = (): boolean => {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}

export const MockModeContext = createContext<IMockModeContext | null>(null)

export const MockModeProvider = ({ children, forceMockMode }: IProps): React.JSX.Element => {
  const [isMockMode, setIsMockMode] = useState<boolean>(forceMockMode ?? readPersistedValue)

  const toggleMockMode = useCallback((): void => {
    setIsMockMode((prev) => {
      const next = !prev
      try {
        localStorage.setItem(STORAGE_KEY, String(next))
      } catch {
        // localStorage unavailable — state still toggles in memory
      }
      return next
    })
  }, [])

  const contextValue = useMemo((): IMockModeContext => ({ isMockMode, toggleMockMode }), [isMockMode, toggleMockMode])

  return <MockModeContext value={contextValue}>{children}</MockModeContext>
}
